module.exports = __webpack_public_path__ + "static/media/placeholder-transparent.e235720d.png";